var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row ajusteLoteEstoque" }, [
    _c("div", { staticClass: "col-sm-2" }, [
      _c("span", [_vm._v(_vm._s(_vm.model.produtoDescricao))]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-sm-2" },
      [
        _vm.isEditQtdLote || _vm.isEdit
          ? _c("combo-component", {
              attrs: {
                id: _vm.model.id + "lote",
                name: _vm.model.id + "lote",
                data: _vm.loteOptions,
                searchable: false,
              },
              on: { input: _vm.onAlteraLote },
              model: {
                value: _vm.model.produtoLoteId,
                callback: function ($$v) {
                  _vm.$set(_vm.model, "produtoLoteId", $$v)
                },
                expression: "model.produtoLoteId",
              },
            })
          : _c("span", [_vm._v(_vm._s(_vm.model.produtoLoteDescricao))]),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-sm-2" }, [
      _c("span", [
        _vm._v(
          _vm._s(_vm.model.quantidadeAtual) +
            " " +
            _vm._s(_vm.model.unidadeMedida)
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-sm-2 ajustaPaddingLote" }, [
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _vm.isEditQtdLote
            ? _c("decimal-component", {
                staticClass: "form-control",
                attrs: {
                  id: _vm.model.id + "quantidadePesagem",
                  name: _vm.model.id + "quantidadePesagem",
                },
                model: {
                  value: _vm.model.quantidadePesagem,
                  callback: function ($$v) {
                    _vm.$set(_vm.model, "quantidadePesagem", $$v)
                  },
                  expression: "model.quantidadePesagem",
                },
              })
            : _c("span", [
                _vm._v(
                  _vm._s(_vm.model.quantidadePesagem) +
                    " " +
                    _vm._s(_vm.model.unidadeMedida)
                ),
              ]),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-sm-2" },
      [
        _c("dateTimePickerComponent", {
          attrs: { id: "dataValidade", name: "dataValidade", disabled: "" },
          model: {
            value: _vm.model.dataValidade,
            callback: function ($$v) {
              _vm.$set(_vm.model, "dataValidade", $$v)
            },
            expression: "model.dataValidade",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-sm-2 text-right" },
      [
        [
          _c(
            "a",
            {
              attrs: {
                href: "#",
                title:
                  "Alterar Lote. Nesse caso o lote será alterado e a quantidade será recalculada automaticamente pelo sistema.",
              },
            },
            [
              _c("i", {
                staticClass: "fas fa-sync-alt",
                style: {
                  color: "#318b9a",
                  fontSize: "25px",
                  marginRight: "10px",
                },
                attrs: { "aria-hidden": "true" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onEditLote($event)
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              attrs: {
                href: "#",
                title:
                  "Alterar Lote e Quantidade. Nesse caso o lote será alterado e a quantidade deverá ser calculada pelo usuário.",
              },
            },
            [
              _c("i", {
                staticClass: "fas fa-exchange-alt",
                style: {
                  color: "#3b5999",
                  fontSize: "25px",
                  marginRight: "10px",
                },
                attrs: { "aria-hidden": "true" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.onEditLoteQuantidade($event)
                  },
                },
              }),
            ]
          ),
          _vm._v(" "),
          _c("a", { attrs: { href: "#", title: "Confirmar alteração" } }, [
            _c("i", {
              staticClass: "fa fa-check",
              style: {
                color: _vm.isEdit || _vm.isEditQtdLote ? "#65bb65" : "#7f7f7f",
                fontSize: "25px",
                marginRight: "10px",
                cursor:
                  _vm.isEdit || _vm.isEditQtdLote ? "pointer" : "not-allowed",
              },
              attrs: { "aria-hidden": "true" },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  _vm.isEdit || _vm.isEditQtdLote
                    ? _vm.onConfirmar(_vm.model)
                    : null
                },
              },
            }),
          ]),
        ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }